import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdCreate, MdDashboard, MdSwapVerticalCircle } from 'react-icons/md';
import { BiTransferAlt } from 'react-icons/bi';
import { HiEyeOff } from 'react-icons/hi';
import { FaUserCog } from 'react-icons/fa';
import { RiSecurePaymentFill } from 'react-icons/ri';
import { useTranslation } from '../Context/LanguageContext';

const SidebarUser = (props) => {
  const { logoutHandle } = props;
  const { t } = useTranslation();

  return (
    <aside
      className='sidenav navbar navbar-vertical navbar-expand-xs fixed-start'
      id='UserSidebar'
    >
      <div className='sidenav-header'>
        <i
          className='fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none'
          aria-hidden='true'
          id='iconSidenav'
        ></i>
        <Link
          to='/dashboard'
          className='navbar-brand m-0 d-flex align-items-center justify-content-center'
        >
          <img
            src='https://www.hvambit.me/assets/logo.png'
            className='navbar-brand-img h-100'
            alt='main_logo'
          />
        </Link>
      </div>
      <hr className='horizontal light mt-0 mb-2' />
      <div
        className='collapse navbar-collapse w-auto h-auto'
        id='sidenav-collapse-main'
      >
        <ul className='navbar-nav'>
          <li className='nav-item'>
            <NavLink to='/dashboard' className='nav-link'>
              <div className='icon'>
                <MdDashboard size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('dashboard')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/agreement-listing' className='nav-link'>
              <div className='icon'>
                <BiTransferAlt size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('transactions')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/create-eccrow/0' className='nav-link'>
              <div className='icon'>
                <MdCreate size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('createEscrow')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/swapp' className='nav-link'>
              <div className='icon'>
                <MdSwapVerticalCircle size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('swapping')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/buy-fiat-money' className='nav-link'>
              <div className='icon'>
                <RiSecurePaymentFill size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('hvamByMoney')}</span>
            </NavLink>
          </li>

          <li className='nav-item mt-3'>
            <h6 className='ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 text-gold'>
              {t('generalSetting')}
            </h6>
          </li>

          <li className='nav-item'>
            <NavLink to='/user-profile' className='nav-link'>
              <div className='icon'>
                <FaUserCog size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('myProfile')}</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink to='/change-password' className='nav-link'>
              <div className='icon'>
                <HiEyeOff size={20} />
              </div>
              <span className='nav-link-text ms-1'>{t('changePassword')}</span>
            </NavLink>
          </li>

          <li className='d-block d-md-none px-2 mt-4'>
            <button
              type='button'
              onClick={() => logoutHandle()}
              className='btn btn-primary w-100'
            >
              {t('signOut')}
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default SidebarUser;
